import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useInstitution } from '../contexts/InstitutionContext';
import {
  INSTITUTION_STUDENT_ONBOARDING_PATH,
  STUDENT_HOME_PATH,
  needsInstitutionStudentOnboarding,
  resolvePostOnboardingPath,
} from '../lib/institutionOnboarding';
import { FullPageLoader } from './ui/page-loader';

/**
 * Redirects new users to onboarding until they complete the funnel.
 * Institution students use institution-specific onboarding, not the consumer funnel.
 */
export function OnboardingGuard({ children }) {
  const { user, loading, isAuthenticated, hasActiveSubscription } = useAuth();
  const { studentMemberships, allMemberships, loading: instLoading } = useInstitution();
  const location = useLocation();

  if (loading || instLoading) {
    return <FullPageLoader message="Loading" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const institutionOnboarding = needsInstitutionStudentOnboarding(user, studentMemberships);
  const onInstitutionPath = location.pathname === INSTITUTION_STUDENT_ONBOARDING_PATH;
  const onConsumerPath = location.pathname === '/onboarding';
  const onStudentHome = location.pathname === STUDENT_HOME_PATH;

  if (user && user.onboarding_completed === false) {
    if (institutionOnboarding) {
      if (!onInstitutionPath) {
        return <Navigate to={INSTITUTION_STUDENT_ONBOARDING_PATH} replace />;
      }
    } else if (!onConsumerPath) {
      return <Navigate to="/onboarding" replace />;
    }
  }

  if (user?.onboarding_completed) {
    if (onConsumerPath || onInstitutionPath) {
      const dest = resolvePostOnboardingPath(allMemberships, hasActiveSubscription);
      return <Navigate to={dest} replace />;
    }
  }

  return children;
}
